import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const VerifyPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const { setTokenAndUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No token found. Please request a new login link.');
      return;
    }

    api.get(`/auth/verify?token=${token}`)
      .then(async (res) => {
        await setTokenAndUser(res.data.token);
        setStatus('success');
        setTimeout(() => navigate('/'), 1500);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Invalid or expired link. Please request a new one.');
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {status === 'loading' && (
          <>
            <div style={styles.spinner} />
            <p style={styles.text}>Logging you in...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>✅</div>
            <p style={styles.text}>Login successful! Redirecting...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={styles.icon}>❌</div>
            <p style={styles.text}>{message}</p>
            <a href="/login" style={styles.link}>Request a new login link</a>
          </>
        )}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: '#F0F4F8',
  },
  card: {
    background: 'white', borderRadius: 12, padding: '48px 40px',
    textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
    minWidth: 320,
  },
  icon: { fontSize: 48, marginBottom: 12 },
  text: { color: '#2952CC', fontSize: 16, fontWeight: 500 },
  spinner: {
    width: 40, height: 40, border: '4px solid #C5D5FF',
    borderTop: '4px solid #2952CC', borderRadius: '50%',
    animation: 'spin 0.8s linear infinite', margin: '0 auto 16px',
  },
  link: { color: '#2952CC', fontSize: 14 },
};

export default VerifyPage;
